






















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import { zeroPadding } from "@/app/core/utility/PrimaryDataUtility";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import CssManager from "@/app/core/css/CssManager";
import { CutInDeclareInfo } from "@/@types/room";
import VueEvent from "@/app/core/decorator/VueEvent";

@Component({
  components: { CtrlButton }
})
export default class SeekBarComponent extends Vue {
  @Prop({ type: Object, required: true })
  private bgmInfo!: CutInDeclareInfo;
  @Prop({ type: Number, required: true })
  private duration!: number;
  @Prop({ type: Number, required: true })
  private seek!: number;

  private isSeekInputting: boolean = false;
  private isMounted: boolean = false;
  private isPlay: boolean = false;

  private useSeek: number = 0;

  private get time() {
    const isHour = this.duration >= 3600;

    const getTime = (num: number): string => {
      num = Math.round(num);
      const hour = Math.floor(num / 3600);
      const minute = Math.floor((num % 3600) / 60);
      const second = num % 60;
      let result = `${zeroPadding(minute, 2)}:${zeroPadding(second, 2)}`;
      if (isHour) result = `${hour}:` + result;
      return result;
    };
    return `${getTime(this.seek)}/${getTime(this.duration)}`;
  }

  @LifeCycle
  private mounted() {
    this.elm.style.setProperty(
      "--seek-base-color",
      CssManager.getCss("--uni-color-gray")
    );
    this.elm.style.setProperty(
      "--seek-font-color",
      CssManager.getCss("--uni-color-white")
    );
    this.useSeek = this.seek;
    this.isMounted = true;
  }

  @VueEvent
  private seekTo(seek: number, allowSeekAhead: boolean) {
    this.$emit("seekTo", seek, allowSeekAhead);
    this.changePlay(true);
    this.isSeekInputting = !allowSeekAhead;
  }

  private get elm(): HTMLDivElement {
    return this.$refs.elm as HTMLDivElement;
  }

  @Watch("seek")
  @Watch("duration")
  private onChangeSeekPer() {
    const per = (this.seek * 100) / this.duration;
    this.elm.style.setProperty("--seek-per", `${per}%`);
    setTimeout(() => {
      this.useSeek = this.seek;
    });
    // if (!this.isSeekInputting) this.seek = this.seek;
  }

  @Watch("isMounted")
  @Watch("isPlay")
  private onChangeIsPlay(isPlay: boolean) {
    this.elm.style.setProperty(
      "--seek-color",
      isPlay
        ? CssManager.getCss("--uni-color-blue")
        : CssManager.getCss("--uni-color-orange")
    );
  }

  private changePlay(isPlay = !this.isPlay): void {
    this.isPlay = isPlay;
    this.$emit(isPlay ? "play" : "pause");
  }
}
